import { render, staticRenderFns } from "./BtnCalendar.vue?vue&type=template&id=6f1f47e5"
import script from "./BtnCalendar.vue?vue&type=script&lang=js"
export * from "./BtnCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports